module.exports = __webpack_public_path__ + "static/media/S4N2-3.2446d82b.svg";